module.exports = __webpack_public_path__ + "media/tang_3.086670ec.mp4";